/** Discriminator for the `useSearchType()` hook return value. */
export const SEARCH_TYPE = {
  ANIMAL: 'animal',
  MEMBERS: 'members',
  MATING: 'mating',
  DOWNLOADS: 'downloads',
  ONLINE_REGISTRATIONS: 'online-registrations',
  SALE_CATALOGUES: 'sale-catalogues',
  SALE_CATALOGUES_DETAIL_ANIMALS: 'sale-catalogues-detail-animals',
  SALE_CATALOGUES_NOTES: 'sale-catalogues-notes',
  SEMEN_CATALOGUES: 'semen-catalogues',
  SEMEN_CATALOGUES_DETAIL_ANIMALS: 'semen-catalogues-detail-animals',
} as const;

export const DETAIL_ANIMAL_SEARCH_TYPES: readonly string[] = [
  SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS,
  SEARCH_TYPE.SEMEN_CATALOGUES_DETAIL_ANIMALS,
];

export const SALE_CATALOGUE_CHILD_SEARCH_TYPES: readonly string[] = [
  SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS,
  SEARCH_TYPE.SALE_CATALOGUES_NOTES,
  SEARCH_TYPE.SEMEN_CATALOGUES_DETAIL_ANIMALS,
];

export const SALE_ID_SEARCH_TYPES: readonly string[] = [
  SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS,
  SEARCH_TYPE.SALE_CATALOGUES_NOTES,
];

export const I4_SEARCH_TYPES: readonly string[] = [
  SEARCH_TYPE.DOWNLOADS,
  SEARCH_TYPE.ONLINE_REGISTRATIONS,
];

/** Society tabs that show the anonymous search-limit screen when the daily cap is reached. */
const RATE_LIMITED_PUBLIC_SEARCH_TYPES: readonly string[] = [
  SEARCH_TYPE.ANIMAL,
  SEARCH_TYPE.MEMBERS,
  SEARCH_TYPE.SALE_CATALOGUES,
  SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS,
  SEARCH_TYPE.SEMEN_CATALOGUES,
  SEARCH_TYPE.SEMEN_CATALOGUES_DETAIL_ANIMALS,
];

export function isRateLimitedPublicSearchType(searchType: string): boolean {
  return (RATE_LIMITED_PUBLIC_SEARCH_TYPES as readonly string[]).includes(
    searchType,
  );
}
